// extracted by mini-css-extract-plugin
export var csatScore = "_mb-5";
export var header = "_mb-1";
export var panelWrapper = "_mb-2";
export var postPreview = "_mb-3";
export var rightContent = "_mb-0";
export var wrappingText = "_mb-4";